document.addEventListener('DOMContentLoaded', () => {
  const onetime = document.querySelector('[data-usp-group="onetime"]');
  const subscription = document.querySelector('[data-usp-group="subscription"]');
  const subscriptionMessage = document.querySelector('.subscription-min-spend');
  const tierSavingsMessage = document.querySelector('.tier-savings-message');

  document.addEventListener('rebuy:smartcart.ready', () => {
    document
      .querySelector('recharge-subscription-widget')
      .shadowRoot.querySelectorAll('[name="purchaseOption"]')
      .forEach((radio) => {
        radio.addEventListener('change', (event) => {
          if (event.target.value === 'onetime') {
            onetime?.classList.remove('hidden');
            tierSavingsMessage?.classList.remove('hidden');
            subscription?.classList.add('hidden');
            subscriptionMessage?.classList.add('onetime', 'hidden');
          } else {
            subscription?.classList.remove('hidden');
            if (
              Number(subscriptionMessage?.dataset.thresholdQty) > 0 &&
              Number(document.querySelector('product-info .quantity__input').value) +
                Number(document.querySelector('tiered-quantity').dataset.cartQty) <
                Number(subscriptionMessage?.dataset.thresholdQty) &&
                parseInt(document.querySelector('tiered-quantity').dataset.threshold) > window?.Rebuy?.SmartCart?.cart?.total_price
            ) {
              subscriptionMessage?.classList.remove('hidden');
            }
            subscriptionMessage?.classList.remove('onetime');
            onetime?.classList.add('hidden');
            tierSavingsMessage?.classList.add('hidden');
          }
        });
      });
  });

  document.querySelector('.pdp-usp__text modal-opener').addEventListener('click', () => {
    document.querySelector('.click-collect-modal #bss-clear-filter')?.click();
  });
});
